var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPanRoof24 = function SvgPanRoof24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.953V6.15c0-.546.11-1.085.326-1.589.215-.504.53-.961.927-1.346a4.285 4.285 0 0 1 1.388-.9A4.388 4.388 0 0 1 9.277 2h5.448c1.134 0 2.221.437 3.023 1.215A4.089 4.089 0 0 1 19 6.15V22M5 10.001S2 9.843 2 13h3m14-2.999s3-.158 3 2.999h-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 10-8 8m4-9-4 4m8 7-2 2",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22V10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16 15-7 7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22V10m-8 9H6.314a1.33 1.33 0 0 1-.93-.377A1.29 1.29 0 0 1 5 17.709v-3.986c0-1.253.506-2.453 1.406-3.339A4.841 4.841 0 0 1 9.8 9h4.402c.63 0 1.254.122 1.836.36a4.806 4.806 0 0 1 1.557 1.023 4.702 4.702 0 0 1 1.406 3.34v3.984c0 .341-.136.67-.38.912-.245.242-.577.38-.924.381H16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPanRoof24;